<div [formGroup]="formGroup">
  <article class="incident-primary-details">
    <div class="section-header">
      @if (!this.incidentsPageStore.isEditMode()) {
        @if (!this.incidentsPageStore.incident()!.isReviewed) {
          <div class="incident-flags-container">
            <p class="incident-flags-container-item is-reviewed-indicator">Under Review</p>
          </div>
        }
      } @else {
        <div class="is-reviewed-slide-toggle" [class.section-disabled]="this.incidentsPageStore.isPending()">
          <mat-slide-toggle formControlName="incidentIsReviewed">Reviewed</mat-slide-toggle>
        </div>
      }
    </div>

    <div class="incident-cards-container">
      @if (!this.incidentsPageStore.isEditMode()) {
        <div class="h1-medium title-card">{{ this.incidentsPageStore.incident()!.title }}</div>
        <div class="summary-card">{{ this.incidentsPageStore.incident()!.summary }}</div>
        <mat-card class="mat-card section-info-card">
          <mat-card-title>Time span of attack</mat-card-title>
          <mat-card-content
            >{{ this.incidentsPageStore.incident()!.startedAt | appDate }}
            @if (this.incidentsPageStore.incident()!.endedAt) {
              <span> - {{ this.incidentsPageStore.incident()!.endedAt | appDate }}</span>
            }
          </mat-card-content>
        </mat-card>
      } @else {
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Title</mat-label>
          <textarea
            class="title-form-input"
            matInput
            cdkTextareaAutosize
            formControlName="incidentTitle"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
          >
          </textarea>
          @if (this.formGroup.get('incidentTitle')?.hasError('required')) {
            <mat-error> Incident title is <strong>required</strong> </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Summary</mat-label>
          <textarea
            class="summary-form-input"
            matInput
            cdkTextareaAutosize
            formControlName="incidentSummary"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="11"
          >
          </textarea>
          @if (this.formGroup.get('incidentSummary')?.hasError('required')) {
            <mat-error> Incident summary is <strong>required</strong> </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [formGroup]="attackPeriodGroup">
          <mat-label>Time span of attack</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              placeholder="Start date"
              for
              formControlName="dateStart"
              readonly
              (click)="picker.open()"
            />
            <input matEndDate placeholder="End date" formControlName="dateEnd" readonly (click)="picker.open()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          @if (attackPeriodGroup.get('dateStart')?.hasError('required')) {
            <mat-error> Start date is mandatory! </mat-error>
          }
        </mat-form-field>
      }

      <mat-card class="mat-card section-info-card" [class.section-disabled]="this.incidentsPageStore.isPending()">
        <mat-card-title>Country of victim</mat-card-title>
        <mat-card-content>
          <span class="country-flag">{{
            CountryFlags[this.incidentsPageStore.incident()!.entity?.countryCode || 'Unknown']
          }}</span
          >{{ CountryDescriptor[this.incidentsPageStore.incident()!.entity?.countryCode || 'Unknown'] }}
        </mat-card-content>
      </mat-card>

      @if (!this.incidentsPageStore.isEditMode()) {
        <mat-card class="mat-card section-info-card">
          <mat-card-title>Motivation of Threat Actor</mat-card-title>
          <mat-card-content>
            {{ MotivationDescriptor[this.incidentsPageStore.incident()!.motivation || 'Unknown'] }}
            <mat-icon
              class="mat-info"
              matTooltip="{{ MotivationTooltips[this.incidentsPageStore.incident()!.motivation || 'Unknown'] }}"
              matTooltipPosition="below"
              matTooltipClass="multiline-tooltip"
              iconPositionEnd
              >info</mat-icon
            >
          </mat-card-content>
        </mat-card>
      } @else {
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Motivation of Threat Actor</mat-label>
          <mat-select formControlName="motivation">
            <mat-select-trigger>
              {{ MotivationDescriptor[formGroup.get('motivation')?.value] }}
            </mat-select-trigger>
            @for (motivation of motivationKeys; track motivation) {
              <mat-option [value]="motivation">
                <div class="motivation-edit-dropdown-value">
                  <div class="motivation-edit-value-name">{{ MotivationDescriptor[motivation] }}</div>
                  <div class="motivation-edit-value-text">{{ MotivationTooltips[motivation] }}</div>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </article>
</div>
